module.exports = __webpack_public_path__ + "img/u85.309d4a72.png";